export default function About() {
  return (
    <section
      id="about"
      className="scroll-mt-24 py-20 px-6 bg-white text-gray-800"
      data-aos="fade-up"
    >
      <div className="max-w-4xl mx-auto text-left transform transition-transform duration-300 hover:scale-[1.01] hover:shadow-xl rounded-lg p-6 hover:bg-gray-50">
        <h2 className="text-3xl font-bold mb-6 transition-colors duration-300 hover:text-green-700 text-center">
          About Me
        </h2>

        <p className="text-lg leading-relaxed mb-4 transition-colors duration-300 hover:text-gray-700">
          A dedicated researcher and developer with a passion for information science and technology.
          I specialize in library modernization and automation using tools like <strong>KOHA</strong>, <strong>DSpace</strong>, and <strong>EPrints</strong>.
        </p>

        <p className="text-lg leading-relaxed mb-4 transition-colors duration-300 hover:text-gray-700">
          My academic background includes a <strong>Master of Library & Information Science</strong> from the University of Kerala and a 
          <strong> BSc in Physics</strong>. I’ve worked with prestigious institutions such as <strong>IIT Hyderabad</strong> and 
          <strong> Digital University of Kerala</strong>, contributing to research initiatives and technical development, particularly within Knowledge Resource Centres.
        </p>

        <p className="text-lg leading-relaxed transition-colors duration-300 hover:text-gray-700">
          I’m committed to driving innovation in the field of Library and Information Science, and constantly seek 
          opportunities to collaborate, grow, and contribute to knowledge systems.
        </p>
      </div>
    </section>
  );
}
